export const filterTaxSchemeEffectiveDate = (date: any, taxSchemeList: any) => {
  const result = JSON.parse(JSON.stringify(taxSchemeList))

  const targetDate = date ? new Date(date) : new Date()
  const targetDateOnly = new Date(
    targetDate.getFullYear(),
    targetDate.getMonth(),
    targetDate.getDate()
  )

  return result.filter(scheme => {
    if (scheme.commonStatus !== 'ACTIVE') {
      return false
    }

    const details = scheme.taxSchemeDetailList
    if (!details || details.length === 0) {
      return false
    }

    const detailsWithDateOnly = details.map(detail => {
      const effectiveDate = new Date(detail.effectiveDate)
      const dateOnly = new Date(
        effectiveDate.getFullYear(),
        effectiveDate.getMonth(),
        effectiveDate.getDate()
      )

      return {
        ...detail,
        effectiveDateObj: dateOnly,
      }
    })

    let validPastDetails = detailsWithDateOnly.filter(
      detail => detail.effectiveDateObj <= targetDateOnly
    )

    if (validPastDetails.length > 0) {
      validPastDetails.sort(
        (a, b) => b.effectiveDateObj.getTime() - a.effectiveDateObj.getTime()
      )
      scheme.taxSchemeDetailList = [
        details.find(
          d => d.effectiveDate === validPastDetails[0].effectiveDate
        ),
      ]
      return true
    }

    const futureDetails = detailsWithDateOnly.filter(
      detail => detail.effectiveDateObj > targetDateOnly
    )

    if (futureDetails.length > 0) {
      futureDetails.sort(
        (a, b) => a.effectiveDateObj.getTime() - b.effectiveDateObj.getTime()
      )
      scheme.taxSchemeDetailList = [
        details.find(d => d.effectiveDate === futureDetails[0].effectiveDate),
      ]
      return true
    }

    return false
  })
}
